import React from "react";
import TeacherFormContainer from "../Container/TeacherFormContainer";
// import AccountFormCommon from "./AccountFormCommon";
import TeacherAccountForm from "./TeacherAccountForm";
import { connect } from "react-redux";
import { API } from "../../API"
import { notify } from "react-notify-toast"

class MyAccount extends React.Component {
  state = {
    current_password: "",
    new_password: "",
    confirm_password: "",
    show_password_current: false,
    show_password_new: false,
    show_password_confirm: false,
    // password_strength: "",
    check_password: [],
    secret_question1: "",
    secret_question2: "",
    secret_answer1: "",
    secret_answer2: "",
    subscribe_newsletter: false,
    subscribe_updates: false,
  }

  handleStateChange = (key, value) => {
    this.setState({ [key]: value })
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleCheckboxChange = (e) => {
    this.setState({ [e.target.id]: e.target.checked })
  }

  onSubmit = (e) => {
    e.preventDefault();

    const fields = [
      "current_password",
      "confirm_password", //only required if new_password is entered
      //secret question/answer fields must be entered all at once
      "secret_question1",
      "secret_answer1",
      "secret_question2",
      "secret_answer2"
    ]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field);
      if (!input.reportValidity()) {
        errors = true;
        break;
      }
    }

    if (!errors) {
      const user = {
        id: this.props.user._id,
        role: "teacher",
        password: this.state.current_password,
      }
      API.confirmPassword({ user: user })
        .then(async (res) => { // if current password is correct
          let success = false;
          let error = false;
          let errorMessage = "No new settings have been entered.";
          if (this.state.new_password) {
            const password_strength = document.querySelector("progress").value; // find a better way to do this?
            if (password_strength >= 2) {
              if (this.state.new_password === this.state.confirm_password) {
                await API.changePassword({
                  user: {
                    id: this.props.user._id,
                    role: "teacher",
                    password: this.state.current_password,
                    newPassword: this.state.new_password
                  },
                })
                  .then(res => {
                    success = true;
                  })
                  .catch(err => {
                    console.log(err)
                    error = true;
                    errorMessage = "Error updating password.";
                  })
              } else {
                error = true;
                errorMessage = "Passwords do not match."
              }
            } else {
              error = true;
              errorMessage = "Check the required password condition."
            }
          }

          if (!error && (this.state.secret_question1 || this.state.secret_answer2)) {
            await API.changeSecretQAndA({
              user: {
                ...user,
                secret_question1: this.state.secret_question1,
                secret_answer1: this.state.secret_answer1,
                secret_question2: this.state.secret_question2,
                secret_answer2: this.state.secret_answer2,
              }
            })
              .then(res => {
                success = true;
              })
              .catch(err => {
                console.log(err)
                error = true;
                errorMessage = "Error updating secret questions.";
              })
          }

          if (success) {
            notify.show("Account settings updated successfully.")
          }
          else {
            notify.show(errorMessage, "error")
          }
        })
        .catch((err) => { // if current password is incorrect
          notify.show("Current password is incorrect", "error")
          console.log(err)
        })
    }
  }

  render() {
    return (
      <TeacherFormContainer
        header="My Account"
        handleSubmit={this.onSubmit}
      >
        {/* <AccountFormCommon
          handleStateChange={this.handleStateChange}
          handleFormFieldChange={this.handleFormFieldChange}
          state={this.state}
        /> */}
        {/* change this to only display for teachers */}
        <TeacherAccountForm
          handleStateChange={this.handleStateChange}
          handleFormFieldChange={this.handleFormFieldChange}
          handleCheckboxChange={this.handleCheckboxChange}
          state={this.state}
        />
      </TeacherFormContainer>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user
  }
}

export default connect(mapStateToProps)(MyAccount);